import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { List, X, Phone, SignOut, UserCircle, CaretDown } from "@phosphor-icons/react";
import { useState } from "react";

const NAV = [
  { to: "/", label: "Ana Sayfa" },
  { to: "/hakkimizda", label: "Kurumsal" },
  { to: "/kurslarimiz", label: "Kurslar" },
  { to: "/fiyatlar", label: "Fiyatlar" },
  { to: "/sss", label: "S.S.S." },
  { to: "/blog", label: "Blog" },
  { to: "/iletisim", label: "İletişim" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { user, logout } = useAuth();
  const nav = useNavigate();

  return (
    <header className="sticky top-0 z-50 bg-white border-b border-stone-200/70" data-testid="navbar">
      {/* Top utility bar */}
      <div className="hidden md:block bg-brand-ink text-stone-300 text-xs">
        <div className="max-w-7xl mx-auto px-6 h-9 flex items-center justify-between">
          <div className="flex items-center gap-5">
            <span><span className="text-stone-500">Pzt-Cum</span> 09:00–19:00</span>
            <span className="opacity-40">·</span>
            <span><span className="text-stone-500">Cmt</span> 09:00–18:00</span>
            <span className="opacity-40">·</span>
            <span className="hidden lg:inline">Hacıhalil Mh. Gümgüm İş Merkezi Kat:1 · Gebze/Kocaeli</span>
          </div>
          <div className="flex items-center gap-5">
            <a href="tel:+902626463646" className="hover:text-white transition-colors">0262 646 3 646</a>
            <a href="mailto:info@estemsurucukursu.com" className="hover:text-white transition-colors hidden lg:inline">info@estemsurucukursu.com</a>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-6 h-[88px] flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center" data-testid="nav-logo">
          <img src="/estem-logo.png" alt="Estem Sürücü Kursu" className="h-16 md:h-20 w-auto object-contain"/>
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {NAV.map(n => (
            <NavLink key={n.to} to={n.to} end={n.to === "/"}
              className={({isActive}) => `px-3.5 py-2 text-sm font-medium rounded-md transition-colors ${isActive ? "text-brand-primary bg-brand-primarySubtle" : "text-stone-700 hover:text-brand-ink hover:bg-stone-100"}`}
              data-testid={`nav-${n.to.replace("/", "") || "home"}`}>
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-2">
          {user ? (
            <>
              <Link to={user.role === "admin" ? "/admin" : "/panelim"} className="nb-btn-outline !px-4 !py-2 !text-xs" data-testid="nav-dashboard"><UserCircle weight="bold" size={16}/> {user.full_name?.split(" ")[0]}</Link>
              <button onClick={() => { logout(); nav("/"); }} className="text-stone-500 hover:text-brand-error p-2 rounded-md hover:bg-stone-100 transition-colors" data-testid="nav-logout"><SignOut weight="bold" size={18}/></button>
            </>
          ) : (
            <>
              <Link to="/giris" className="text-sm font-medium text-stone-700 hover:text-brand-ink px-3 py-2" data-testid="nav-login">Giriş</Link>
              <Link to="/basla" className="nb-btn !px-5 !py-2.5" data-testid="nav-register">Online Kayıt</Link>
            </>
          )}
        </div>

        <button className="lg:hidden p-2 rounded-lg border border-stone-200" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
          {open ? <X size={20} weight="bold"/> : <List size={20} weight="bold"/>}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-stone-200 bg-white" data-testid="nav-mobile-menu">
          <div className="px-4 py-4 flex flex-col gap-1">
            {NAV.map(n => (
              <NavLink key={n.to} to={n.to} end={n.to === "/"} onClick={() => setOpen(false)}
                className={({isActive}) => `px-4 py-2.5 text-sm font-medium rounded-md ${isActive ? "bg-brand-primarySubtle text-brand-primary" : "text-stone-700 hover:bg-stone-100"}`}>
                {n.label}
              </NavLink>
            ))}
            <div className="flex gap-2 mt-3 pt-3 border-t border-stone-200">
              {user ? (
                <Link to={user.role === "admin" ? "/admin" : "/panelim"} onClick={() => setOpen(false)} className="nb-btn flex-1">Panelim</Link>
              ) : (
                <>
                  <Link to="/giris" onClick={() => setOpen(false)} className="nb-btn-outline flex-1">Giriş</Link>
                  <Link to="/basla" onClick={() => setOpen(false)} className="nb-btn flex-1">Online Kayıt</Link>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
